<ion-header class="ion-hide-lg-up g" mode="ios">
  <header-main></header-main>
</ion-header>

<ion-content fullscreen #content *ngIf="authService.user | async as user" class="g">
  <header class="ion-hide-lg-up">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-icon size="large" src="assets/icons/profile.svg" color="white" class="ion-margin-start"></ion-icon>
      </ion-buttons>
      <ion-title>My Dashboard</ion-title>
    </ion-toolbar>
  </header>
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1 color="white"><ion-icon src="assets/icons/profile.svg" color="white"></ion-icon>My Dashboard</h1>
  </header>

  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col class="ion-hide-lg-down ion-no-padding menu gigs" size-lg="3" size-xl="2">
        <menu-account></menu-account>
      </ion-col>
      <ion-col class="dashboard ion-no-padding">
        <div class="popup" *ngIf="user.welcome">
          <ion-card color="primary">
            <ion-card-content>
              <ion-card-title>
                Before we get started
              </ion-card-title>
              <p>To unlock these services, you will need to update your profile.</p>
            </ion-card-content>
          </ion-card>
        </div>
        <ion-grid>
          <ion-row>
            <ion-col class="ion-no-padding" size="12">
              <ion-card class="intro">
                <ion-grid class="ion-no-padding welcome">
                  <ion-row *ngIf="user.welcome" routerDirection="root" routerLink="/account/profile/">
                    <ion-col size="12" size-md="6">
                      <ion-card-header>
                        <ion-card-title color="primary">
                          Welcome to gigexchange
                        </ion-card-title>
                      </ion-card-header>
                      <ion-card-content>
                        <p>To get started, please update your profile.</p>
                      </ion-card-content>
                    </ion-col>
                    <ion-col class="feed" size="12" size-md="6">
                      <ion-card-content class="ion-padding-right">
                        <ion-progress-bar color="secondary" value="0.1"></ion-progress-bar>
                        <ion-button color="secondary" shape="round" fill="solid" routerDirection="root" routerLink="/account/profile/" class="ion-float-right ion-margin-bottom">Edit Profile</ion-button>
                        <p><strong>Services: <a>10% enabled</a></strong></p>
                      </ion-card-content>
                    </ion-col>
                  </ion-row>
                  <ion-row *ngIf="!user.welcome">
                    <ion-col size="12" size-md="6">
                      <ng-container *ngIf="!user.gigster">
                        <ion-card-header>
                          <ion-card-title color="primary">
                            Thanks, {{user.firstname}} — ready to go.
                          </ion-card-title>
                        </ion-card-header>
                        <ion-card-content>
                          <p>Review and enable your services below.</p>
                        </ion-card-content>
                      </ng-container>
                      <ng-container *ngIf="user.gigster && user.stripeAccount && user.stripeAccount.payouts_enabled">
                        <ion-card-header>
                          <ion-card-title color="primary">
                            Thanks, {{user.firstname}} — ready to go.
                          </ion-card-title>
                        </ion-card-header>
                        <ion-card-content>
                          <p>Review and enable your services below.</p>
                        </ion-card-content>
                      </ng-container>
                      <ng-container *ngIf="user.gigster && !(user.stripeAccount && user.stripeAccount.payouts_enabled)">
                        <ion-card-header>
                          <ion-card-title color="primary">
                            Hey {{user.firstname}}, — payouts not enabled.
                          </ion-card-title>
                        </ion-card-header>
                        <ion-card-content>
                          <p>Please update your Gig Worker profile with required info.</p>
                        </ion-card-content>
                      </ng-container>
                    </ion-col>
                    <ion-col class="feed" size="12" size-md="6">
                      <ion-card-content class="ion-padding-right">
                        <ion-progress-bar color="secondary" [value]="percent/100"></ion-progress-bar>
                        <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerDirection="root" routerLink="/account/profile/" class="ion-float-right ion-margin-bottom">Edit Profile</ion-button>
                        <p><strong>Services: <a>{{percent | number}}% enabled</a></strong></p>
                      </ion-card-content>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="ion-no-padding" size="12" size-sm="6" size-xl="3">
              <ion-card class="feature gigs ion-text-center dashboard" [disabled]="user.welcome">
                <ion-card-header routerDirection="root" routerLink="/account/profile/gigs">
                  <ion-card-title>
                    <ion-icon src="assets/icons/gigs.svg"></ion-icon>
                    Gigs
                  </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/account/profile/gigs/">Edit Profile</ion-button>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Gig Lister</ion-card-subtitle>
                  <p>Pay experts to do tasks</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.giglister" checked color="secondary" mode="md" (ionChange)="updateGigLister(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.giglister" color="secondary" mode="md" (ionChange)="updateGigLister(true)"></ion-toggle>
                    <ion-label *ngIf="user.giglister" class="ion-text-left" color="secondary">On</ion-label>
                    <ion-label *ngIf="!user.giglister" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.giglister && user.firstname && user.email && user.country">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/account/gigs/create/">List a gig</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.giglister && !(user.firstname && user.email && user.country)">
                    <p>Update lister profile</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.giglister">
                    <p>Update lister profile</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateGigLister(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Gig Worker</ion-card-subtitle>
                  <p>Earn some extra income</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.gigster" checked color="secondary" mode="md" (ionChange)="updateGigWorker(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.gigster" color="secondary" mode="md" (ionChange)="updateGigWorker(true)"></ion-toggle>
                    <ion-label *ngIf="user.gigster" class="ion-text-left" color="secondary">On</ion-label>
                    <ion-label *ngIf="!user.gigster" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.gigster && user.stripeAccount && user.stripeAccount.payouts_enabled">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/gigs/">Find a gig</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.gigster && !(user.stripeAccount && user.stripeAccount.payouts_enabled)">
                    <p>Complete account setup</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/gigs/">Get Set up</ion-button>
                    <div class="popup account" *ngIf="user.stripeAccount">
                      <ion-card color="tertiary">
                        <ion-card-content>
                          <ion-card-title color="white">
                            Account setup
                          </ion-card-title>
                          <p *ngIf="!user.stripeAccount.tos_acceptance.date">Setup your account with stripe, let us know your company or individual details.</p>
                          <p *ngIf="user.stripeAccount.tos_acceptance.date && !user.stripeAccount.external_accounts.data.length">Register your bank account with stripe, so we can pay you out when the gig is done.</p>
                          <p *ngIf="user.stripePerson && user.stripePerson.requirements.currently_due.indexOf('verification.document') !== -1">Identity document e.g. Passport or ID required.</p>
                          <p *ngIf="user.stripePerson && user.stripePerson.verification.document.front && user.stripePerson.requirements.currently_due.indexOf('verification.additional_document') !== -1">Additional document showing proof of address required.</p>
                          <p *ngIf="user.stripePerson && user.stripePerson.verification.document.front && user.stripePerson.verification.additional_document.front && user.stripePerson.verification.status !== 'verified'">Remember to check back in a few hours after stripe has validated.</p>
                        </ion-card-content>
                      </ion-card>
                    </div>    
                  </ng-container>
                  <ng-container *ngIf="!user.gigster">
                    <p>Just 3 easy steps</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateGigWorker(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
              </ion-card>
            </ion-col>
            <ion-col class="ion-no-padding" size="12" size-sm="6" size-xl="3">
              <ion-card class="feature jobs ion-text-center" [disabled]="user.welcome">
                <ion-card-header routerDirection="root" routerLink="/account/profile/jobs">
                  <ion-card-title>
                    <ion-icon src="assets/icons/jobs.svg"></ion-icon>
                    Jobs
                  </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  <ion-button color="primary" [disabled]="user.welcome" shape="round" routerLink="/account/profile/jobs/">Edit Profile</ion-button>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Job Lister</ion-card-subtitle>
                  <p>List a job to hire staff</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.joblister" checked color="primary" mode="md" (ionChange)="updateJobLister(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.joblister" color="primary" mode="md" (ionChange)="updateJobLister(true)"></ion-toggle>
                    <ion-label *ngIf="user.joblister" class="ion-text-left" color="primary">On</ion-label>
                    <ion-label *ngIf="!user.joblister" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.joblister && user.firstname && user.email && user.country">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/account/jobs/create/">List a job</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.joblister && !(user.firstname && user.email && user.country)">
                    <p>Update lister profile</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.joblister">
                    <p>Update lister profile</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateJobLister(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Job Hunter</ion-card-subtitle>
                  <p>Hunt for your next role</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.jobhunter" checked color="primary" mode="md" (ionChange)="updateJobHunter(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.jobhunter" color="primary" mode="md" (ionChange)="updateJobHunter(true)"></ion-toggle>
                    <ion-label *ngIf="user.jobhunter" class="ion-text-left" color="primary">On</ion-label>
                    <ion-label *ngIf="!user.jobhunter" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.jobhunter && user.available && user.classification && user.experience">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/jobs/">Find a job</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.jobhunter && !(user.available && user.classification && user.experience)">
                    <p>Complete account setup</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/jobs/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.jobhunter">
                    <p>Just 3 easy steps</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateJobHunter(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
              </ion-card>
            </ion-col>
            <ion-col class="ion-no-padding" size="12" size-sm="6" size-xl="3">
              <ion-card class="feature volunteers ion-text-center" [disabled]="user.welcome">
                <ion-card-header routerDirection="root" routerLink="/account/profile/volunteers">
                  <ion-card-title>
                    <ion-icon src="assets/icons/volunteers.svg"></ion-icon>
                    Volunteers
                  </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/volunteers/">Edit Profile</ion-button>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Requestor</ion-card-subtitle>
                  <p>List ad to find volunteers</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.volseeker" checked color="warning" mode="md" (ionChange)="updateVolseeker(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.volseeker" color="warning" mode="md" (ionChange)="updateVolseeker(true)"></ion-toggle>
                    <ion-label *ngIf="user.volseeker" class="ion-text-left" color="warning">On</ion-label>
                    <ion-label *ngIf="!user.volseeker" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.volseeker">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/account/volunteers/create/">List Ad</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.volseeker && !(user.firstname && user.email && user.country)">
                    <p>Update lister profile</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.volseeker">
                    <p>Update lister profile</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateVolseeker(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Volunteer</ion-card-subtitle>
                  <p>Want to volunteer</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.volunteer" checked color="warning" mode="md" (ionChange)="updateVolunteer(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.volunteer" color="warning" mode="md" (ionChange)="updateVolunteer(true)"></ion-toggle>
                    <ion-label *ngIf="user.volunteer" class="ion-text-left" color="warning">On</ion-label>
                    <ion-label *ngIf="!user.volunteer" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.volunteer && user.available && user.classification && user.experience">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/volunteers/">Find a volunteer</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.volunteer && !(user.available && user.classification && user.experience)">
                    <p>Complete account setup</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/volunteers/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.volunteer">
                    <p>Just 3 easy steps</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateVolunteer(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
              </ion-card>
            </ion-col>
            <ion-col class="ion-no-padding" size="12" size-sm="6" size-xl="3">
              <ion-card class="feature promote ion-text-center" [disabled]="user.welcome">
                <ion-card-header routerDirection="root" routerLink="/account/profile/promote">
                  <ion-card-title>
                    <ion-icon src="assets/icons/promote.svg"></ion-icon>
                    Promote
                  </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  <ion-button color="ultra-violet" [disabled]="user.welcome" shape="round" routerLink="/account/profile/promote/">Edit Profile</ion-button>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Promoter</ion-card-subtitle>
                  <p>List ad for services</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.promoter" checked color="ultra-violet" mode="md" (ionChange)="updatePromoter(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.promoter" color="ultra-violet" mode="md" (ionChange)="updatePromoter(true)"></ion-toggle>
                    <ion-label *ngIf="user.promoter" class="ion-text-left" color="ultra-violet">On</ion-label>
                    <ion-label *ngIf="!user.promoter" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.promoter && user.firstname && user.email && user.country">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/account/promote/create/">List Ad</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.promoter && !(user.firstname && user.email && user.country)">
                    <p>Update promoter profile</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/promote/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.promoter">
                    <p>Update promoter profile</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updatePromoter(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
                <ion-card-content>
                  <ion-card-subtitle>Customer</ion-card-subtitle>
                  <p>Need to find services</p>
                  <ion-item>
                    <ion-label class="ion-text-right" color="medium">Off</ion-label>
                    <ion-toggle *ngIf="user.customer" checked color="ultra-violet" mode="md" (ionChange)="updateCustomer(false)"></ion-toggle>
                    <ion-toggle *ngIf="!user.customer" color="ultra-violet" mode="md" (ionChange)="updateCustomer(true)"></ion-toggle>
                    <ion-label *ngIf="user.customer" class="ion-text-left" color="ultra-violet">On</ion-label>
                    <ion-label *ngIf="!user.customer" class="ion-text-left" color="medium">On</ion-label>
                  </ion-item>
                  <ng-container *ngIf="user.customer && user.firstname && user.email && user.country">
                    <p>All set and ready to go</p>
                    <ion-button color="secondary" [disabled]="user.welcome" shape="round" routerLink="/promote/">Find services</ion-button>
                  </ng-container>
                  <ng-container *ngIf="user.customer && !(user.firstname && user.email && user.country)">
                    <p>Update customer profile</p>
                    <ion-button color="warning" [disabled]="user.welcome" shape="round" routerLink="/account/profile/promote/">Get Set up</ion-button>
                  </ng-container>
                  <ng-container *ngIf="!user.customer">
                    <p>Update customer profile</p>
                    <ion-button color="tertiary" [disabled]="user.welcome" (click)="updateCustomer(true)" shape="round">Get Started</ion-button>
                  </ng-container>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</ion-footer>
